import { SpeakerWithDetails, Pronouns } from '../types/speaker-types';
import { screenShareBarsColors, sharedVideoBarsColors, SPEAKER_COLOR_COUNT } from '../constants/speakerColors';
import { getSpeakerImage } from './speakerUtils';

const getSpeakerColorAttributes = (index: number) => {
  const slot = index % SPEAKER_COLOR_COUNT;
  return {
    color: `speaker-text-${slot}`,
    bgColor: `speaker-bg-${slot}`,
    lightBgColor: `speaker-light-bg-${slot}`,
    hoverBgColor: `speaker-hover-bg-${slot}`
  };
};

export const normalizeSpeakerDetails = (
  speakerDetails: Record<string, SpeakerWithDetails>
): Record<string, SpeakerWithDetails> => {
  if (!speakerDetails) {
    return {};
  }
  const result: Record<string, SpeakerWithDetails> = {};
  Object.keys(speakerDetails).forEach((id, index) => {
    const speaker = speakerDetails[id];
    result[id] = {
      ...speaker,
      key: speaker.key || id,
      profile_picture_url: getSpeakerImage(speaker?.profile_picture_url),
      ...(!speaker.color ? getSpeakerColorAttributes(index) : {})
    };
  });
  return result;
};

export const buildScreenshareSpeakerDetails = (
  stageTimeSpans: Array<{ start_time: number; end_time: number }>
): SpeakerWithDetails => {
  const speakingSlots = Object.fromEntries(stageTimeSpans.map(span => [String(span.start_time), span.end_time]));

  return {
    first_name: 'Shared Screen',
    last_name: '',
    id: 'screen-share',
    key: 'screen-share',
    color: screenShareBarsColors.textColor,
    bgColor: screenShareBarsColors.bgColor,
    lightBgColor: screenShareBarsColors.lightBgColor,
    hoverBgColor: screenShareBarsColors.hoverBgColor,
    speakingSlots,
    parent_id: '',
    company: '',
    title: '',
    profile_picture_url: '',
    pronouns: Pronouns.HE
  };
};

export const buildSharedVideoSpeakerDetails = (
  stageTimeSpans: Array<{ start_time: number; end_time: number }>
): SpeakerWithDetails => {
  const speakingSlots = Object.fromEntries(stageTimeSpans.map(span => [String(span.start_time), span.end_time]));

  return {
    first_name: 'Shared Video',
    last_name: '',
    id: 'shared-video',
    key: 'shared-video',
    color: sharedVideoBarsColors.textColor,
    bgColor: sharedVideoBarsColors.bgColor,
    lightBgColor: sharedVideoBarsColors.lightBgColor,
    hoverBgColor: sharedVideoBarsColors.hoverBgColor,
    speakingSlots,
    parent_id: '',
    company: '',
    title: '',
    profile_picture_url: '',
    pronouns: Pronouns.HE
  };
};
